/*
 *  Campaign__Create_ChannelDataSelectList.jsx
 *
 */
//==============================================================================
// External dep.
//==============================================================================
import React, { useMemo } from "react";
import Select from "react-select";
import styled from "styled-components";
//------------------------------------------------------------------------------
// Internal dep.
//------------------------------------------------------------------------------
//------------------------------------------------------------------------------
// Styled Components
//------------------------------------------------------------------------------
const SelectLabel = styled.div`
  font-weight: 500;
  font-size: 14px;
  margin-bottom: 6px;
`;
//------------------------------------------------------------------------------
// Main Functional Component
//------------------------------------------------------------------------------
const ChannelDataSelectList = ({
  label,
  options,
  value,
  dataKey,
  updateChannelData,
  editable,
  showLabel = true
}) => {
  const formattedOptions = useMemo(
    () => options.map((option) => ({ value: option, label: option })),
    [options]
  );

  return (
    <>
      {showLabel && <SelectLabel>{label}</SelectLabel>}
      {!editable ? (
        value
      ) : (
        <Select
          placeholder={label}
          value={value ? { value, label: value } : null}
          onChange={(selected) => updateChannelData({ key: dataKey, value: selected.value })}
          options={formattedOptions}
          styles={{
            menuList: (provided) => ({
              ...provided,
              justifyContent: "flex-start !important"
            })
          }}
        />
      )}
    </>
  );
};

export default ChannelDataSelectList;
